/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".swiper[_ngcontent-%COMP%]{--swiper-theme-color:#fe4d01;width:100%;height:600px}.swiper[_ngcontent-%COMP%]   .swiper-slide[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]{height:600px}.swiper[_ngcontent-%COMP%]   .swiper-pagination-bullet[_ngcontent-%COMP%] + .swiper-pagination-bullet-active[_ngcontent-%COMP%]{background:var(--swiper-theme-color)!important}"];
export { styles as styles };
